import store from '@/store'

export default function hasPer(id) {
  let res = false
  const baseInfo = store.state.system.userInfo
  if (baseInfo) {
    if (id) {
      const { userid } = baseInfo
      if (userid == id) {
        res = true
      }
    } else {
      res = true
    }
  }
  return res
}
